export function FinalCTA() {
  return (
    <section className="py-24 bg-white" id="contact-form">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Upgrade Your Website and Get Found Online
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 mb-4">
            Modern websites combined with powerful search visibility
          </p>
          <p className="text-3xl font-bold text-teal-600">
            Starting at $399/month
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 md:p-12 shadow-xl border-2 border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Request Your Website + SEO Plan
          </h3>

          <form 
            action="https://readdy.ai/api/form/d6rccdma739gopmlhjdg"
            method="POST"
            data-readdy-form
            className="space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              // Validate required fields
              const requiredFields = ['name', 'business', 'email', 'phone'];
              const missingFields = requiredFields.filter(field => !formData.get(field));
              
              if (missingFields.length > 0) {
                alert('Please fill in all required fields');
                return;
              }

              // Validate textarea length
              const message = formData.get('message') as string;
              if (message && message.length > 500) {
                alert('Message must be 500 characters or less');
                return;
              }

              // Submit form
              fetch(form.action, {
                method: 'POST',
                body: new URLSearchParams(formData as any),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              })
                .then(response => {
                  if (response.ok) {
                    alert('Thank you! We will contact you within 24 hours.');
                    form.reset();
                  } else {
                    alert('Something went wrong. Please try again.');
                  }
                })
                .catch(() => {
                  alert('Something went wrong. Please try again.');
                });
            }}
          >
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-gray-900"
                  placeholder="John Smith"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Business Name *
                </label>
                <input
                  type="text"
                  name="business"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-gray-900"
                  placeholder="Your Business Name"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-gray-900"
                  placeholder="john@business.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Phone *
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-gray-900"
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Current Website URL (if applicable)
              </label>
              <input
                type="text"
                name="website"
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-gray-900"
                placeholder="yourbusiness.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                What's your biggest challenge in attracting new customers? (Max 500 characters)
              </label>
              <textarea
                name="message"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none transition-colors resize-none text-gray-900"
                placeholder="Tell us about your current situation..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Are you ready to invest $399/month in SEO to grow your business? *
              </label>
              <div className="space-y-2">
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="investment"
                    value="Yes"
                    className="w-4 h-4 text-teal-500 cursor-pointer"
                  />
                  <span className="text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="investment"
                    value="I need more details"
                    className="w-4 h-4 text-teal-500 cursor-pointer"
                  />
                  <span className="text-gray-700">I need more details</span>
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="investment"
                    value="Not sure yet"
                    className="w-4 h-4 text-teal-500 cursor-pointer"
                  />
                  <span className="text-gray-700">Not sure yet</span>
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-lg font-bold text-lg hover:from-teal-600 hover:to-cyan-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Submit My Application
            </button>

            <p className="text-xs text-gray-500 text-center">
              By submitting this form, you agree to be contacted by Digital Age Marketing via phone, email, or text regarding your inquiry.
            </p>
          </form>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Or call us directly</p>
          <a 
            href="tel:8004559670"
            className="inline-flex items-center gap-3 text-3xl font-bold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            800-455-9670
          </a>
        </div>
      </div>
    </section>
  );
}